import { SchoolService, BaseService } from "@/services/school.service";

const ResourceService = {

    getLibrary(type, title, page, pageSize) {

        // types
        let typesParam = (type.value != undefined && type.value != "") ? "&types=" + type.value.toLowerCase() : ""

        let titleParam = (title != undefined && title.length > 0) ? "&title=" + title.toLowerCase() : ""

        return SchoolService.getAll("resources/library?visibility=member" + typesParam + titleParam + "&page=" + page + "&results_per_page=" + pageSize )
    },

    add(payload) {
    	return SchoolService.create("resources", payload)
    },

    delete(result) {
    	return SchoolService.delete("resources", result.identifier, null)
    },

    // UNIT BASED

    getForUnit(courseId) {
        return SchoolService.getAll("courses/" + courseId + "/resources?visibility=private")
    },

    getForLesson(lessonId) {
        return SchoolService.getAll("lessons/" + lessonId + "/resources?visibility=private")
    },
}

export { ResourceService };